import { render } from "./SelectOption.vue?vue&type=template&id=140c1eea&ts=true"
import script from "./SelectOption.vue?vue&type=script&lang=ts"
export * from "./SelectOption.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__